import React from 'react';
import * as Ui from './styles';

export function CheckButton({
  // Atributo de Tag HTML
  id,
  // Texto de exibição
  label,
  // Atributo de agrupamento da Tag HTML
  name,
  // Define se o check está ou não selecionado
  checked,
  // Define que o componente será renderizado sobre um fundo escuro
  dark = false,
  // Valor do check
  value,
  // Define se o ícone de marcação aparecerá ou não
  withIcon = true,
  // Propaga o evento de seleção do check
  onChange,
  // styles by class
  className,
}) {
  return (
    <Ui.Container className={className}>
      <Ui.Label className="check-button">
        <input
          id={id}
          title={label}
          name={name}
          checked={checked}
          value={value}
          type="checkbox"
          className={'check-button-input'}
          onChange={onChange}
        />
        {withIcon && (<span className={dark ? 'check-button-control dark' : 'check-button-control'} />)}
        <span className="check-button-label" htmlFor={id}>{label}</span>
      </Ui.Label>
    </Ui.Container>
  );
}
